import { useEffect, useState } from 'react'
import { useNavigate, Navigate } from 'react-router'
import { useSelector } from 'react-redux'
import useHttp from '@/shared/hooks/useHttp'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import useBusinessType from '@/shared/hooks/useBusinessType'
import { useTranslation } from 'react-i18next'

const CreateForm = () => {
  const { t } = useTranslation()
  const allowedCountries = ['be', 'it']
  const [data, setData] = useState(null)
  const navigate = useNavigate()
  const { loaderRoutes, loaderRoutesEnergy, loaderRoutesInsurance, authTokenSession, country } =
    useSelector(selectAuthData)
  const { getApplicationUrl, type: applicationType } = useBusinessType({
    loaderRoutesEnergy,
    loaderRoutes,
    loaderRoutesInsurance,
    modulesStatuses: {},
    modulesStatusesEnergy: {},
    modulesStatusesInsurance: {},
  })
  const initUrl = getApplicationUrl('telesales-add') ?? ''
  const token = authTokenSession
  const { sendRequest, getConfig } = useHttp({ token })
  const initialize = params => {
    const search = window.location.search ?? ''
    let countryUrl = initUrl

    if (search) {
      countryUrl += search + '&lang=' + country
    } else {
      countryUrl += '?lang=' + country
    }

    if (params) {
      countryUrl += params
    }

    sendRequest(countryUrl, getConfig('GET'), json => {
      setData(json)
    })
  }

  useEffect(() => {
    //close for all except BE and IT for now
    if (!allowedCountries.includes(country)) {
      alert(t('subscriptionForm.access_error.v1_closed'))
      navigate('/' + applicationType)
      return
    }

    initialize()
  }, [])

  if (!data?.id) {
    return <p>Creation du contrat en cours....</p>
  }

  return <Navigate to={'/' + applicationType + '/subscription/edit/' + data.id} />
}

export default CreateForm
